import type { PropsWithChildren, ReactNode } from "react";
import { StyledDropdownLabel, StyledLabelWrapper } from "./styles";

type Props = PropsWithChildren<{
    className?: string;
    text: ReactNode;
}>;

const SignalDropdownLabel = ({ children, text, className }: Props) => {
    return (
        <StyledLabelWrapper className={className}>
            <StyledDropdownLabel>{text}</StyledDropdownLabel>
            {children}
        </StyledLabelWrapper>
    );
};

export default SignalDropdownLabel;
